<template>
  <div class="app-header" :class="color" :style="{'top': top0?'0':''}">
    <div class="top" v-if="inRnApp" :style="topStyles"></div>
    <div class="header" v-if="checkInApp()!='h5'">
      <div v-if="color==='is-primary'" class="header-left-icon" slot="leftIcon" @click="back">
        <span class="icon">
          <img src="@/assets/icons/width_left.svg" alt="" />
        </span>
      </div>
      <div v-if="color==='is-default'" class="header-left-icon" slot="leftIcon" @click="back">
        <span class="icon">
          <img src="@/assets/icons/black_left.svg" alt="" />
        </span>
      </div>
      <span class="header-title">{{ current_title | titleLimit }}</span>
      <div v-if="color==='is-primary'" class="header-right-icon" slot="rightIcon" @click="share">
        <span class="icon">
          <img src="@/assets/icons/width_share.svg" alt="" />
        </span>
      </div>
      <div v-if="color==='is-default'" class="header-right-icon" slot="rightIcon" @click="share">
        <span class="icon">
          <img src="@/assets/icons/black_share.svg" alt="" />
        </span>
      </div>
    </div>
    <div class="downapp" v-if="!inRnApp">
      <a :href="'https://app.jaadee.com/do.php?canal=app&fp=RN&uid=' + referee_id">
        <img class="" src="../../assets/images/downapp.jpg" alt="">
      </a>
    </div>
  </div>
</template>

<script>
  import config,{inApp,isTest} from "../../config";
  import {setStatusTextColor } from "../../RNApp";
  export default {
    name: "app-header",
    components: {},
    props: {
      title: {
        type: String,
        default() {
          return "";
        }
      },
      color:{
        type:String,
        default() {
          return "is-default";
        }
      },
      is_display_down:{
        type:Boolean,
        default() {
          return true;
        }
      },
      top0: {
        default: false
      }
    },
    data() {
      return {
        current_title: "",
        topStyles: {
          height: "0.27rem"
        },
        referee_id: 0
      };
    },
    computed: {
      inRnApp(){
        if (inApp()) {
          return true
        } else if (this.checkInApp() == 'wechat' || this.checkInApp() == 'app') {
          return true
        } else {
          return false
        }
      }
    },
    filters: {
      titleLimit(val) {
        if (val.length > 16) {
          return val.substring(0, 14) + "...";
        } else {
          return val;
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        let referee_string = this.$route.query.uid || 0;
        referee_string = referee_string + "";
        this.referee_id = referee_string.split(",")[0];
        let height = this.$route.query.statusBarH;
        if (height > 0) {
          this.topStyles.height = +height + "px";
        }
        this.setStatus();
      });
    },
    methods: {
      back() {
        if (!inApp()) {
          this.$router.go(-1);
          return true;
        }
        let params = {
          scene: "back",
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(params));
      },
      share() {
        let query = this.$route.query;
        let query_string = "?";
        Object.keys(query).forEach((value, index) => {
          if (value !== "inApp") {
            if (index === Object.keys(query).length - 1) {
              query_string += value + "=" + query[value];
            } else {
              query_string += value + "=" + query[value] + "&";
            }
          }
        });
        const app_url = isTest() ? config.appUrl.pro : config.appUrl.dev;
        let share_description = this.$route.meta.share_description || this.current_title;
        let share_title = this.$route.meta.share_title || this.current_title;
        let share_image = this.$route.meta.share_image || "https://share.jaadee.net/h5/tjr/img/share.jpg";
        let params = {
          scene: "share",
          params: {
            name: '翡翠王朝'+share_title,
            url:
                    `${app_url}/page/#` +
                    this.$route.path +
                    query_string,
            desc: share_description,
            logo: share_image
          }
        };
        // console.log(params)
        window.ReactNativeWebView.postMessage(JSON.stringify(params));
      },
      setTitle() {
        if (this.title.length > 0) {
          this.current_title = this.title;
        } else {
          this.current_title = this.$route.meta.title;
        }
      },
      setStatus() {
        if (this.$route.query.inApp == 6) {
          //setStatusTextColor("black");
        }
      },
      checkInApp() {
        if(this.getQueryString('inApp') == 0 || this.getQueryString('inApp') == false){
          return 'h5'
        } else if (this.getQueryString('inApp') == 3){
          return 'wechat'
        } else {
          return 'app'
        }
      },
      getQueryString(variable){
        if (this.$route.query[variable]) {
          return this.$route.query[variable]
        }
        return false
      }
    },
    watch: {
      title: {
        handler: "setTitle",
        immediate: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .app-header {
    position: fixed;
    z-index: 1;
    .top {
      height: 0.27rem;
    }
    .header {
      position: relative;
      width: 100vw;
      height: 0.59rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 0.16rem;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      .header-left-icon {
        position: absolute;
        left: 0.16rem;
        height: 100%;
        display: flex;
        align-items: center;
        .icon {
          width: 0.27rem;
          height: 0.27rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .header-right-icon {
        position: absolute;
        right: 0.16rem;
        height: 100%;
        display: flex;
        align-items: center;
        .icon {
          width: 0.27rem;
          height: 0.27rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .downapp{
    display: flex;
    a{
      display: flex;
      img{
        height: 0.65rem;
        width: 100vw;
      }
    }
  }
  .app-header.is-default {
    background-color: rgba(255, 255, 255, 1);
    .header{
      .header-left-icon .icon,.header-right-icon .icon {
          width: 0.4rem;
          height: 0.4rem;
          img {
            width: 100%;
            height: 100%;
          }
      }
      .header-left-icon {
        position: absolute;
        left: 0.16rem;
        height: 100%;
        display: flex;
        align-items: center;
        .icon {
          width: 0.4rem;
          height: 0.4rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .header-title{
        font-size:0.24rem;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
    }
  }
  .app-header.is-primary {
    background-color: rgba(1, 30, 3, 1);
    .header{
      border: none;
      .header-title{
        color: rgba(255,255,255,1);
      }
    }
  }
</style>
